// CC-Common imports
import { Utils } from 'cc-common';
// Constants import
import { URLConstants } from '../../_constants/url-constants';
import { CiraHelpKeyConstants } from '../../_constants/cira-help-key-constants';
import * as i0 from "@angular/core";
export class CiraHelpService {
    getHelpLinkById(helpId, communityId) {
        return this.getHelpLink(helpId, null, communityId);
    }
    getHelpLinkByKey(helpKey, communityId) {
        return this.getHelpLink(null, helpKey, communityId);
    }
    getHelpLink(helpId, helpKey, communityId) {
        let helpLink = URLConstants.ciranetHelpUrl;
        let contextStr = '';
        let helpIdStr = '';
        let helpKeyStr = '';
        if (!!communityId) {
            contextStr = `/ct/c${communityId}`;
        }
        if (!!helpId) {
            helpIdStr = `/${helpId}`;
        }
        else if (!!helpKey) {
            helpKeyStr = `&key=${helpKey}`;
        }
        helpLink = helpLink.replace('{CONTEXT}', contextStr);
        helpLink = helpLink.replace('{HELP_ID}', helpIdStr);
        helpLink += helpKeyStr;
        return helpLink;
    }
    showHelp(helpURL) {
        const win = window.open(`${helpURL.startsWith('/') ? helpURL.replace('/', '') : helpURL}`, '_blank');
        if (Utils.notNullAndDefined(win)) {
            win.focus();
        }
    }
    getCommunityCalendarHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.communityCalendar, communityId);
    }
    getCommunityInformationHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.communityInformation, communityId);
    }
    getCommunityDashboardHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.communityDashboard, communityId);
    }
    getCommunityBoardOfDirectorHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.communityBoardOfDirector, communityId);
    }
    getCommunityLegalInformationHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.communityLegalInformation, communityId);
    }
    getCommunityResidentDirectoryHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.communityResidentDirectory, communityId);
    }
    getCommunityRestrictionSummaryHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.communityRestrictionSummary, communityId);
    }
    getPropertyRestrictionSummaryHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyRestrictionSummary, communityId);
    }
    getPropertyReportViolationHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.communityReportViolation, communityId);
    }
    getPropertyArchitechturalApplicationHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyArchitechturalApplication, communityId);
    }
    getPropertyDocumentsHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyDocuments, communityId);
    }
    getPropertyDashboardHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyDashboard, communityId);
    }
    getPropertyInfoHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyInformation, communityId);
    }
    getPropertyOwnerInfoHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyOwnerInformation, communityId);
    }
    getPropertyContactInfoHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyContactInformation, communityId);
    }
    getPropertyDirectorySharingHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyDirectorySharing, communityId);
    }
    getPropertyOwnerStatementHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyAccountStatement, communityId);
    }
    getPropertyAdditionalInfoHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyAdditionalInfo, communityId);
    }
    getPropertyComplianceHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyCompliance, communityId);
    }
    getPropertyNotesHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyNotes, communityId);
    }
    getPropertyCommunicationHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyCommunication, communityId);
    }
    getOneTimePaymentHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyOneTimePayment, communityId);
    }
    getRecurringPaymentHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyRecurringPayment, communityId);
    }
    getPropertyStatusesHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.propertyStatuses, communityId);
    }
    getCommunityDelinquencyHelpLink(communityId) {
        return this.getHelpLink(null, CiraHelpKeyConstants.communityDelinquencyDetail, communityId);
    }
}
CiraHelpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CiraHelpService_Factory() { return new CiraHelpService(); }, token: CiraHelpService, providedIn: "root" });
